import { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar"
import ListJobSkills from "../../components/job-skills/list-jobSkills/ListJobSkills"
import axios from "axios";
import { Loaders } from "../Loaders";

function ListJobSkillsPage() {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }
  const jobSkillData = async () => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-skills?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res.data);
      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("Error");
    }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/job-skills?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }

  useEffect(() => {
    jobSkillData(1);
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `https://abarishr.hennainternational.in/api/job-skills/delete/${id}`
      );
      jobSkillData(1)
    } catch (error) {
      alert("Error");
    }
  };
  const onChangeVal = (e) => {
    // console.log(e);
    jobSkillData(e)

  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title=" Job Skills" />
        <h3 className="page-title">
          Manage Job Skills
        </h3>
        <ListJobSkills data={data} handleDelete={handleDelete} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} jobSkillData={jobSkillData} reset={reset} />
      </div>
    </>
  )
}
export default ListJobSkillsPage